import React from "react";
import styled from "styled-components";
import { Grid, TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import inputComponentMask from "../../../../../lib/inputMask";
import { UnstyledDateField } from "../../../../Global/Fields/Date";

import SectionHeader from "./SectionHeader";

const styles = () => ({
  inputField: {
    borderBottom: "1px solid #2196F3",
    "&:focused": {
      borderBottom: "1px solid #006dab"
    }
  },
  labelRoot: {
    fontSize: "17px"
  }
});

const DateFieldWrapper = styled.div`
  & div:first-child {
    width: 100%;
  }
  & label {
    font-size: 17px;
  }
  &&&&& div div::before {
    border-bottom: 1px solid #2196f3;
  }
  &&&&& div div:hover::before {
    border-bottom: 1px solid #2196f3;
  }
  &&&&& div div::after {
    border-bottom: 1px solid #006dab;
  }
`;

const DispositionInfo = props => {
  const { handleChange, values } = props; // formik props
  const { classes } = props;

  return (
    <div>
      <SectionHeader>Disposition</SectionHeader>
      <Grid container direction="row" spacing={16}>
        <Grid item xs={3}>
          <DateFieldWrapper>
            <UnstyledDateField label="Projected Exit Date" id="pedField" name="projectedExitDate" clearable value={values.projectedExitDate} />
          </DateFieldWrapper>
        </Grid>
        <Grid item xs={3}>
          <DateFieldWrapper>
            <UnstyledDateField label="Actual Exit Date" id="aedField" name="actualExitDate" clearable value={values.actualExitDate} />
          </DateFieldWrapper>
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            label="Sales Price"
            id="salesPriceField"
            type="text"
            name="salesPrice"
            value={values.salesPrice || ""}
            onChange={handleChange}
            InputLabelProps={{
              FormLabelClasses: {
                root: classes.labelRoot
              }
            }}
            InputProps={{
              classes: {
                input: classes.inputField
              },
              disableUnderline: true,
              inputComponent: inputComponentMask({
                mask: "currency"
              })
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            label="Price Per Unit"
            id="pricePerUnitField"
            type="text"
            name="pricePerUnit"
            value={values.pricePerUnit || ""}
            onChange={handleChange}
            InputLabelProps={{
              FormLabelClasses: {
                root: classes.labelRoot
              }
            }}
            InputProps={{
              classes: {
                input: classes.inputField
              },
              disableUnderline: true,
              inputComponent: inputComponentMask({
                mask: "currency"
              })
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            label="Price Per Square Foot"
            id="pricePerSquareFootField"
            type="text"
            name="pricePerSquareFoot"
            value={values.pricePerSquareFoot || ""}
            onChange={handleChange}
            InputLabelProps={{
              FormLabelClasses: {
                root: classes.labelRoot
              }
            }}
            InputProps={{
              classes: {
                input: classes.inputField
              },
              disableUnderline: true,
              inputComponent: inputComponentMask({
                mask: "currency"
              })
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            label="Equity Multiple"
            id="equityMultipleField"
            type="text"
            name="equityMultiple"
            value={values.equityMultiple || ""}
            onChange={handleChange}
            InputLabelProps={{
              FormLabelClasses: {
                root: classes.labelRoot
              }
            }}
            InputProps={{
              classes: {
                input: classes.inputField
              },
              disableUnderline: true,
              inputComponent: inputComponentMask({
                mask: "twoDecimalNumber"
              })
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(DispositionInfo);
